// src/hooks/hotelRatings/useCreateHotelRating.js
import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { createHotelRating } from "../../api/apiHotelRatings";
import { useNavigate } from "react-router-dom";
import parseError from "../../utils/parseError";

const useCreateHotelRating = () => {
    const queryClient = useQueryClient();
    const navigate = useNavigate();

    const { mutate: createHotelRatings, isPending } = useMutation({
        mutationFn: createHotelRating,
        onSuccess: (res) => {
            const message = res?.message || "Hotel rating created successfully";
            toast.success(message);
            queryClient.invalidateQueries({ queryKey: ["hotelRatings"] });
            navigate("/hotel-ratings");
        },
        onError: (error) => {
            const msg = parseError(error);
            toast.error(msg || "Failed to create hotel rating");
        },
    });

    return { createHotelRatings, isPending };
};

export default useCreateHotelRating;
